import React from 'react';
import { connect } from 'react-redux';
import { userActions } from '../actions';
import logo1 from '../img/eastlogo1.jpg';
import logo2 from '../img/eastlogo2.jpg';
import { bake_cookie,versionCookie, read_cookie } from '../helpers/cookieHelper';

function mapStateToProps(state) {
    const { loggingIn } = state.authentication;
    return {
        loggingIn
    };
}

class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            submitted: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { username, password } = this.state;
        const { dispatch } = this.props;
        if (username && password) {
            dispatch(userActions.login(username, password));
        }
    }

    cookieChecker =()=>{
        const version = read_cookie(versionCookie)
        if(!version){
          bake_cookie(versionCookie,{verlist:[]})
        }
      }

    componentDidMount(){
    this.cookieChecker();
    }

    render() {
        const { loggingIn } = this.props;
        const { username, password, submitted } = this.state;
        return (
          <div className='login-container-east'>
            <div className="col-md-6 col-md-offset-3 login-container-east__block">
                <div className='east-login-block'>
                    <h2>EOL社群聆聽系統</h2>
                    <h4>Eastern Online Co., Ltd.</h4>
                    <form className='form' name="form" onSubmit={this.handleSubmit}>
                        <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                            <label htmlFor="username">使用者名稱</label>
                            <input type="text" className="form-control" name="username" value={username} onChange={this.handleChange} />
                            {submitted && !username &&
                                <div className="help-block">Username is required</div>
                            }
                        </div>
                        <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                            <label htmlFor="password">密碼</label>
                            <input type="password" className="form-control" name="password" value={password} onChange={this.handleChange} />
                            {submitted && !password &&
                                <div className="help-block">Password is required</div>
                            }
                        </div>
                        <div className='login-button'>
                            <button className="btn">登入</button>
                            {loggingIn}
                        </div>
                    </form>
                </div>

                <div className='east-logo-1'>
                    <img src={logo1} alt="east-logo"/>
                </div>
                
                <div className='intro-btn'>
                    <a href='http://help.isurvey.com.tw/social/c.html'>
                        <button className='video_btn'>系統簡介影片</button>
                    </a>
                    <a href='mailto:service@isurvey.com.tw'>
                        <button className='mail_btn' title='service@isurvey.com.tw'>服務聯繫信箱</button>
                    </a>   
                </div>
            </div>
            <div className='east-logo-2'>
                    <a href='http://www.isurvey.com.tw'><img src={logo2} alt="east-logo"/></a>
                </div>
          </div>
        );
    }
}

const connectedLoginPage = connect(mapStateToProps)(LoginPage);
export { connectedLoginPage as LoginPage };



// WEBPACK FOOTER //
// ./src/components/LoginPageEast.js